<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p3"><span class="sz"><b>Just Ducky</b></span></p>
<p class="p4"><span class="sz">A Lexie Starr Mystery</span></p>
<p class="p4"><span class="sz"><i>Book Five</i></span></p>
<p class="p5"><span class="sz"> </span></p>
<p class="p4"><span class="sz">by</span></p>
<p class="p5"><span class="sz"> </span></p>
<p class="p4"><span class="sz">Jeanne Glidewell</span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?0ab14250